import '../UsageStatisticsReport/UsageStatisticsReport.css';

import { useEffect } from 'react';

import { HistoricalReportTable } from '../HistoricalReportTable';
import { NewUsageStatisticsReport } from '../UsageStatisticsReport/NewUsageStatisticsReport';

function SubscriptionsTypesReport({
  // functions
  generateSubscriptionTypesReport,
  getSubscriptionTypesReports,
  // state
  subscriptionTypesReports,
  subscriptionTypesReportsIsLoading,
}) {
  useEffect(() => {
    getSubscriptionTypesReports();
  }, []);

  return (
    <>
      <div className="usage-statistics-report">
        <hr />
        <div>
          <h2>Subscription Types Report</h2>
          <NewUsageStatisticsReport
            reports={subscriptionTypesReports}
            generateUsageReport={generateSubscriptionTypesReport}
            usageStatisticsReportsIsLoading={subscriptionTypesReportsIsLoading}
          />
        </div>

        <div>
          <h4 style={{ marginTop: '50px' }}>
            Subscription Types Report History
          </h4>
          <HistoricalReportTable
            reports={subscriptionTypesReports}
            loading={subscriptionTypesReportsIsLoading}
            columns={[
              'id',
              'status',
              'createdAtParsed',
              'fromDate',
              'untilDate',
              'link',
            ]}
          />
        </div>
      </div>
    </>
  );
}

export default SubscriptionsTypesReport;
